var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"product-category-header"},[_c('button',{staticClass:"product-category-header__title",attrs:{"data-test-title-btn":""},on:{"click":_vm.showProducts}},[_c('span',[_vm._v(_vm._s(("My " + _vm.categoryTitle)))]),_c('Badge',{attrs:{"value":_vm.totalItems,"hidden":_vm.areAllItemsFetched}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40af2508","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductCategory/ProductCategoryHeader/ProductCategoryHeader.vue
// module id = null
// module chunks = 